// Minnesota ZIP Code to County Mapping
// Comprehensive mapping for accurate county determination

export interface ZipCountyMapping {
  [zipCode: string]: string;
}

// Accurate ZIP code to county mapping for Minnesota
export const MN_ZIP_COUNTY_MAPPINGS: ZipCountyMapping = {
  // Washington County
  "55016": "Washington County",
  "55025": "Washington County",
  "55042": "Washington County",
  "55043": "Washington County",
  "55047": "Washington County",
  "55082": "Washington County",
  "55090": "Washington County",

  // Dakota County
  "55024": "Dakota County",
  "55044": "Dakota County",
  "55054": "Dakota County",
  "55068": "Dakota County",
  "55075": "Dakota County",
  "55076": "Dakota County",
  "55077": "Dakota County",
  "55120": "Dakota County",
  "55121": "Dakota County",
  "55122": "Dakota County",
  "55123": "Dakota County",
  "55124": "Dakota County",
  "55150": "Dakota County",
  "55306": "Dakota County",

  // Ramsey County
  "55101": "Ramsey County",
  "55102": "Ramsey County",
  "55103": "Ramsey County",
  "55104": "Ramsey County",
  "55105": "Ramsey County",
  "55106": "Ramsey County",
  "55107": "Ramsey County",
  "55108": "Ramsey County",
  "55109": "Ramsey County",
  "55110": "Ramsey County",
  "55112": "Ramsey County",
  "55113": "Ramsey County",
  "55114": "Ramsey County",
  "55115": "Ramsey County",
  "55116": "Ramsey County",
  "55117": "Ramsey County",
  "55118": "Ramsey County",
  "55119": "Ramsey County",
  "55130": "Ramsey County",

  // Wright County
  "55301": "Wright County",
  "55313": "Wright County",
  "55320": "Wright County",
  "55321": "Wright County",
  "55328": "Wright County",
  "55341": "Wright County",
  "55362": "Wright County",
  "55376": "Wright County",
  "55382": "Wright County",
  "55387": "Wright County",
  "55398": "Wright County",

  // Anoka County
  "55304": "Anoka County",
  "55316": "Anoka County",

  // Hennepin County
  "55311": "Hennepin County",
  "55369": "Hennepin County",
  "55374": "Hennepin County",
  "55401": "Hennepin County",
  "55402": "Hennepin County",
  "55403": "Hennepin County",
  "55404": "Hennepin County",
  "55405": "Hennepin County",
  "55406": "Hennepin County",
  "55407": "Hennepin County",
  "55408": "Hennepin County",
  "55409": "Hennepin County",
  "55410": "Hennepin County",
  "55411": "Hennepin County",
  "55412": "Hennepin County",
  "55413": "Hennepin County",
  "55414": "Hennepin County",
  "55415": "Hennepin County",
  "55416": "Hennepin County",
  "55417": "Hennepin County",
  "55418": "Hennepin County",
  "55419": "Hennepin County",
  "55420": "Hennepin County",
  "55421": "Hennepin County",
  "55422": "Hennepin County",
  "55423": "Hennepin County",
  "55424": "Hennepin County",
  "55425": "Hennepin County",
  "55426": "Hennepin County",
  "55427": "Hennepin County",
  "55428": "Hennepin County",
  "55429": "Hennepin County",
  "55430": "Hennepin County",
  "55431": "Hennepin County",
  "55432": "Hennepin County",
  "55433": "Hennepin County",
  "55434": "Hennepin County",
  "55435": "Hennepin County",
  "55436": "Hennepin County",
  "55437": "Hennepin County",
  "55438": "Hennepin County",
  "55439": "Hennepin County",
  "55441": "Hennepin County",
  "55442": "Hennepin County",
  "55443": "Hennepin County",
  "55444": "Hennepin County",
  "55445": "Hennepin County",
  "55446": "Hennepin County",
  "55447": "Hennepin County",
  "55450": "Hennepin County",
  "55454": "Hennepin County",
  "55455": "Hennepin County",
  "55456": "Hennepin County",
  "55457": "Hennepin County",
  "55458": "Hennepin County",
  "55459": "Hennepin County",
  "55460": "Hennepin County",
  "55461": "Hennepin County",
  "55462": "Hennepin County",
  "55463": "Hennepin County",
  "55464": "Hennepin County",
  "55465": "Hennepin County",
  "55466": "Hennepin County",
  "55467": "Hennepin County",
  "55468": "Hennepin County",
  "55469": "Hennepin County",
  "55470": "Hennepin County",
  "55471": "Hennepin County",
  "55472": "Hennepin County",
  "55473": "Hennepin County",
  "55474": "Hennepin County",
  "55475": "Hennepin County",
  "55476": "Hennepin County",
  "55477": "Hennepin County",
  "55478": "Hennepin County",
  "55479": "Hennepin County",
  "55480": "Hennepin County",
  "55481": "Hennepin County",
  "55482": "Hennepin County",
  "55483": "Hennepin County",
  "55484": "Hennepin County",
  "55485": "Hennepin County",
  "55486": "Hennepin County",
  "55487": "Hennepin County",
  "55488": "Hennepin County",
  "55489": "Hennepin County",
  "55490": "Hennepin County",
  "55491": "Hennepin County",
  "55492": "Hennepin County",
  "55493": "Hennepin County",
  "55494": "Hennepin County",
  "55495": "Hennepin County",
  "55496": "Hennepin County",
  "55497": "Hennepin County",
  "55498": "Hennepin County",
  "55499": "Hennepin County",

  // Scott County
  "55315": "Scott County",
  "55317": "Scott County",
  "55337": "Scott County",
  "55352": "Scott County",
  "55372": "Scott County",
  "55378": "Scott County",
  "55379": "Scott County",

  // Carver County
  "55318": "Carver County",
  "55322": "Carver County",
  "55331": "Carver County",
  "55360": "Carver County",
  "55367": "Carver County",
  "55368": "Carver County",
  "55386": "Carver County",

  // St. Louis County
  "55802": "St. Louis County",
  "55803": "St. Louis County",
  "55804": "St. Louis County",
  "55805": "St. Louis County",
  "55806": "St. Louis County",
  "55807": "St. Louis County",
  "55808": "St. Louis County",
  "55810": "St. Louis County",
  "55811": "St. Louis County",
  "55812": "St. Louis County",

  // Olmsted County
  "55901": "Olmsted County",
  "55902": "Olmsted County",
  "55904": "Olmsted County",
  "55905": "Olmsted County",
  "55906": "Olmsted County",

  // Stearns County
  "56301": "Stearns County",
  "56303": "Stearns County",
  "56304": "Stearns County",
};

// Function to get county from ZIP code (primary method) or address information
export const getCountyFromAddress = (
  address: string,
  city: string,
  state: string,
  zipCode?: string,
  countyName?: string
): string => {
  // PRIMARY METHOD: Use county_name from backend if available
  if (countyName && countyName.trim()) {
    return countyName;
  }

  // SECONDARY METHOD: Try ZIP code lookup
  // IMPORTANT: Only apply MN ZIP → county mapping when the provider's state is MN.
  // This prevents accidentally assigning a Minnesota county to providers in other states
  // that might share the same ZIP pattern or in case of data issues.
  const normalizedZip = zipCode?.trim().split(".")[0];
  const normalizedState = state?.toUpperCase();
  if (
    normalizedZip &&
    normalizedState === "MN" &&
    MN_ZIP_COUNTY_MAPPINGS[normalizedZip]
  ) {
    const foundCounty = MN_ZIP_COUNTY_MAPPINGS[normalizedZip];
    return foundCounty;
  }

  // TERTIARY METHOD: Try to extract from address if it contains county information
  const addressLower = address?.toLowerCase() || "";
  if (addressLower.includes("county")) {
    const countyMatch = address.match(/([A-Za-z\s]+County)/i);
    if (countyMatch) {
      return countyMatch[1];
    }
  }

  // FALLBACK: Return city and state if no county found
  const normalizedCity = city?.trim();
  const normalizedStateForFallback = state?.toUpperCase();
  return normalizedCity && normalizedStateForFallback
    ? `${normalizedCity}, ${normalizedStateForFallback}`
    : "Unknown Location";
};

// Export all Minnesota counties for reference
export const MN_COUNTIES = [
  "Aitkin County",
  "Anoka County",
  "Becker County",
  "Beltrami County",
  "Benton County",
  "Big Stone County",
  "Blue Earth County",
  "Brown County",
  "Carlton County",
  "Carver County",
  "Cass County",
  "Chippewa County",
  "Chisago County",
  "Clay County",
  "Clearwater County",
  "Cook County",
  "Cottonwood County",
  "Crow Wing County",
  "Dakota County",
  "Dodge County",
  "Douglas County",
  "Faribault County",
  "Fillmore County",
  "Freeborn County",
  "Goodhue County",
  "Grant County",
  "Hennepin County",
  "Houston County",
  "Hubbard County",
  "Isanti County",
  "Itasca County",
  "Jackson County",
  "Kanabec County",
  "Kandiyohi County",
  "Kittson County",
  "Koochiching County",
  "Lac qui Parle County",
  "Lake County",
  "Lake of the Woods County",
  "Le Sueur County",
  "Lincoln County",
  "Lyon County",
  "McLeod County",
  "Mahnomen County",
  "Marshall County",
  "Martin County",
  "Meeker County",
  "Mille Lacs County",
  "Morrison County",
  "Mower County",
  "Murray County",
  "Nicollet County",
  "Nobles County",
  "Norman County",
  "Olmsted County",
  "Otter Tail County",
  "Pennington County",
  "Pine County",
  "Pipestone County",
  "Polk County",
  "Pope County",
  "Ramsey County",
  "Red Lake County",
  "Redwood County",
  "Renville County",
  "Rice County",
  "Rock County",
  "Roseau County",
  "St. Louis County",
  "Scott County",
  "Sherburne County",
  "Sibley County",
  "Stearns County",
  "Steele County",
  "Stevens County",
  "Swift County",
  "Todd County",
  "Traverse County",
  "Wabasha County",
  "Wadena County",
  "Waseca County",
  "Washington County",
  "Watonwan County",
  "Wilkin County",
  "Winona County",
  "Wright County",
  "Yellow Medicine County",
];
